import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import loginActions from 'redux/actions/loginActions'
import { loginSelectors } from 'redux/selectors'
import { localize } from 'helpers/translator'
import loginErrorCodes from 'helpers/enums/loginErrorCodes'

const LoginSSOErrorConfirm = props => (
	<Confirm
		btTwo={localize('login_sso_error_confirm_button')}
		alertMessage={getErrorMessage(props.lerr)}
		actionButtonType={0}
		actionTwo={() => {
			props.actions.loginSSOErrorConfirmConfirmed()
		}}
		closeButton={false}
	/>
)

function getErrorMessage(error) {
	switch (error) {
		case loginErrorCodes.LOGIN_SSO_ERROR_MESSAGE_LTI:
			return localize('login_sso_error_message_lti')
		case loginErrorCodes.LOGIN_SIGNUP_ERROR_MESSAGE_LTI:
			return localize('login_signup_error_message_lti')
	}
	return ''
}

function mapStateToProps(state) {
	return loginSelectors.loginSsoErrorSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		loginSSOErrorConfirmConfirmed: loginActions.loginSSOErrorConfirmConfirmed,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginSSOErrorConfirm)
